module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('b', [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-438db324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StrategySelector.vue
// module id = 844
// module chunks = 1